import React from 'react';

const titleHeaderStyle = {
    border: '1px solid #374151',
    padding: '10px 14px',
    textAlign: 'center',
    backgroundColor: '#4b5563',
    color: '#fff',
    fontWeight: 600,
    fontSize: '14px',
};

const headerStyle = {
    border: '1px solid #e5e7eb',
    padding: '10px 14px',
    textAlign: 'center',
    backgroundColor: '#6b7280',
    color: '#fff',
    fontWeight: 600,
    fontSize: '13px',
};

const cellStyle = {
    border: '1px solid #e5e7eb',
    padding: '10px 14px',
    textAlign: 'center',
    fontSize: '13px',
    color: '#1f2937',
};

const labelCellStyle = {
    ...cellStyle,
    textAlign: 'left',
    fontWeight: 500,
};

const rankHighlightStyle = {
    ...cellStyle,
    backgroundColor: '#fef9c3',
};

const tableStyle = {
    border: '1px solid #e5e7eb',
    borderCollapse: 'collapse',
    width: '100%',
};

const AirlineRow = ({ airline }) => (
    <tr>
        <td style={labelCellStyle}>{airline.airline}</td>
        <td style={cellStyle}>{airline.preAdviseRank}</td>
        <td style={cellStyle}>{airline.prmVolumeRank}</td>
        <td style={cellStyle}>{airline.total}</td>
        <td style={rankHighlightStyle}>{airline.rank}</td>
    </tr>
);

const AirlinePerformanceCombinedTable = ({ airlines = [] }) => {
    if (!airlines?.length) {
        return <p style={{ fontSize: '14px', color: '#6b7280' }}>No airline data available.</p>;
    }

    return (
        <div style={{ marginBottom: '24px' }}>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={titleHeaderStyle} colSpan={5}>
                            Airline Performance
                        </th>
                    </tr>
                    <tr>
                        <th style={{ ...headerStyle, textAlign: 'left' }}>Airline</th>
                        <th style={headerStyle}>Pre-Advise Rank</th>
                        <th style={headerStyle}>PRM Volume Rank</th>
                        <th style={headerStyle}>Total</th>
                        <th style={headerStyle}>Rank</th>
                    </tr>
                </thead>
                <tbody>
                    {airlines.map((airline) => (
                        <AirlineRow key={airline.airlineCode} airline={airline} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AirlinePerformanceCombinedTable;
